module.exports = __webpack_public_path__ + "img/abyss_logo_white.5a0e969b.png";